import * as React from "react";
const SvgMiniPlay = (props) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M12 0c6.627 0 12 5.373 12 12s-5.373 12-12 12S0 18.627 0 12 5.373 0 12 0ZM9.918 7.157A1.302 1.302 0 0 0 8 8.232v7.535a1.302 1.302 0 0 0 1.918 1.077l7.403-3.767a1.194 1.194 0 0 0 0-2.154Z"
      fill={props.color}
      fillRule="evenodd"
    />
  </svg>
);
export default SvgMiniPlay;
